module.exports = __webpack_public_path__ + "static/media/envelope-solid.29ed48e3.png";